module.exports = {"230724100":"新青镇","230724101":"红星镇","230724102":"五营镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230724.json
// module id = 850
// module chunks = 0